import { useCasinoStore } from '../stores/useCasinoStore'

export default defineNuxtPlugin({
  name: 'initCasinoStore',
  order: 3,
  async setup() {
    useCasinoStore()
  },
})
